<template>
  <ReviewsBlock
    v-if="rating && !reviewsError"
    id="customer-reviews"
    :ai-summary="null"
    :ai-summary-pending="false"
    :next-reviews-cursor="reviews?.nextCursor"
    :pending-summary="ratingSummaryPending"
    :previous-reviews-cursor="reviews?.previousCursor"
    :product-id="undefined"
    :rating
    :rating-summary
    :reviews="reviews?.results || []"
    :reviews-pending="pendingReviews"
  />
</template>

<script setup lang="ts">
import type { Rating } from '@backmarket/http-api/src/api-specs-reviews/types/rating'

import ReviewsBlock from '~/scopes/reviews/reviews-display/components/ReviewsBlock/ReviewsBlock.vue'

import { useSellerRatingDetails } from '../../composables/useSellerRatingDetails'
import { useSellerReviews } from '../../composables/useSellerReviews'

defineProps<{
  rating?: Rating
}>()

const {
  data: reviews,
  pending: pendingReviews,
  error: reviewsError,
} = useSellerReviews()

const { data: ratingSummary, pending: ratingSummaryPending } =
  useSellerRatingDetails()
</script>
